export const E2E_BYPASS_STORE_HOURS_KEY = 'e2e_bypass_store_hours';

/**
 * Playwright E2E starts with ?disable_exp=1. Persist a session flag so Find a
 * Bakery / store-details View Menu stays available even when US store hours
 * say Closed (CI often runs outside Eastern open hours).
 */
export const isE2EStoreHoursBypassEnabled = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const params = new URLSearchParams(window.location.search || '');
    if (
      params.get('disable_exp') === '1' ||
      params.get('e2e_bypass_hours') === '1'
    ) {
      window.sessionStorage.setItem(E2E_BYPASS_STORE_HOURS_KEY, '1');
      return true;
    }

    return window.sessionStorage.getItem(E2E_BYPASS_STORE_HOURS_KEY) === '1';
  } catch (e) {
    return false;
  }
};
